export const allowedFilesExtensions = /(\.jpg|\.doc|\.docx|\.txt|\.pdf|\.jpeg|\.png)$/i;